import Cookies from "js-cookie";

export function extractTimeOderDate(dateString) {
    let today = new Date();

    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0, 0);
    const todayMorning = today.getTime();      //бугінгі уакыт 00:00 

    const date = new Date(dateString);
    const messageMoment = date.getTime();   //бугінгі уакыт осы сәтте
    if (messageMoment >= todayMorning) {
        const hours = padZero(date.getHours());
        const minutes = padZero(date.getMinutes());
        return `${hours}:${minutes}`;
    } else {
        return date.toJSON().slice(0, 10);
    }
}
export function extractTime(dateString) {
    let today = new Date();

    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0, 0);

    const date = new Date(dateString);
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    return `${hours}:${minutes}`;
}

export function extractDate(dateString) {
    const date = new Date(dateString);
    return date.toJSON().slice(0, 10);
}

// Helper function to pad single-digit numbers with a leading zero
function padZero(number) {
    return number.toString().padStart(2, "0");
}

export const getCsrfToken = () => {
    const csrfToken = Cookies.get('XSRF-TOKEN'); 
    return csrfToken;
};

export const getAuthConfig = (userToken) => {
    return {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
            "x-xsrf-token": Cookies.get("XSRF-TOKEN"), // Біз жана токенді тікелей печеньеден аламыз
        },
        withCredentials: true,
    };
};
